var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHyve(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hyveLogo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 96",
    style: {
      enableBackground: "new 0 0 103 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#04FFE1;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.2077,
    y1: 24.0679,
    x2: 101.0508,
    y2: 87.2178
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#04FFE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#121922"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54,86.2V68.7L69.3,60l15.3,8.7v17.5l-15.3,8.7L54,86.2z M18.3,86.2V68.7L33.6,60l15.3,8.7v17.5l-15.3,8.7 L18.3,86.2z M0.5,56.7V39.2l15.3-8.7L31,39.2v17.5l-15.3,8.7L0.5,56.7z M36.2,56.7V39.2l15.3-8.7l15.3,8.7v17.5l-15.3,8.7 L36.2,56.7z M71.8,56.7V39.2l15.2-8.7l15.3,8.7v17.5l-15.3,8.7L71.8,56.7z M54,27.2V9.7L69.3,1l15.3,8.7v17.5l-15.3,8.7L54,27.2z  M18.3,27.2V9.7L33.6,1l15.3,8.7v17.5l-15.3,8.7L18.3,27.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.3,1.2l15.1,8.6v17.2l-15.1,8.6l-15.1-8.6V9.8L69.3,1.2 M33.6,1.2l15.1,8.6v17.2l-15.1,8.6l-15.1-8.6V9.8 L33.6,1.2 M15.7,30.7l15.1,8.6v17.2l-15.1,8.6L0.7,56.6V39.3L15.7,30.7 M51.4,30.7l15.1,8.6v17.2l-15.1,8.6l-15.1-8.6V39.3 L51.4,30.7 M87.1,30.7l15.1,8.6v17.2l-15.1,8.6L72,56.6V39.3L87.1,30.7 M69.3,60.2l15.1,8.6v17.2l-15.1,8.6l-15.1-8.6V68.8 L69.3,60.2 M33.6,60.2l15.1,8.6v17.2l-15.1,8.6l-15.1-8.6V68.8L33.6,60.2 M69.3,0.8L53.8,9.6v17.7l15.5,8.8l15.5-8.8V9.6L69.3,0.8 L69.3,0.8z M33.6,0.8L18.1,9.6v17.7l15.5,8.8L49,27.3V9.6L33.6,0.8L33.6,0.8z M87.1,30.3l-15.5,8.9v17.7l15.5,8.8l15.5-8.8V39.1 L87.1,30.3L87.1,30.3z M51.4,30.3L36,39.1v17.7l15.5,8.8l15.5-8.8V39.1L51.4,30.3L51.4,30.3z M15.7,30.3L0.3,39.1v17.7l15.5,8.8 l15.5-8.8V39.1L15.7,30.3L15.7,30.3z M69.3,59.8l-15.5,8.8v17.7l15.5,8.9l15.5-8.9V68.6L69.3,59.8L69.3,59.8z M33.6,59.8l-15.5,8.8 v17.7l15.5,8.9L49,86.3V68.6L33.6,59.8L33.6,59.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyve);
export default __webpack_public_path__ + "static/media/hyve.826237d9c4c96ba7d4366750d53226a0.svg";
export { ForwardRef as ReactComponent };